import { render } from "./ShopForm.vue?vue&type=template&id=e4234f52&scoped=true"
import script from "./ShopForm.vue?vue&type=script&lang=js"
export * from "./ShopForm.vue?vue&type=script&lang=js"

import "./ShopForm.vue?vue&type=style&index=0&id=e4234f52&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4234f52"]])

export default __exports__